// extracted by mini-css-extract-plugin
export default {"main":"Social_main__u3-bq","next":"Social_next__xVQG6"};